import { memo, useMemo, useState } from "react";
import CrownGuidelineImage from "../../../assets/guideline-images/crown.png"
import RightGuidelineImage from "../../../assets/guideline-images/right.png"
import LeftGuidelineImage from "../../../assets/guideline-images/left.png"

const CaptureGuidelines = (props) => {
    const {
        onAcceptGuidelines,
    } = props;

    const [activeSlideIndex, setActiveSlideIndex] = useState(0)

    const isLastSlide = activeSlideIndex === 2;

    const [imageType, imageSrc, description, buttonText] = useMemo(() => {
        switch (activeSlideIndex) {
            case 0:
                return [
                    "Crown image",
                    CrownGuidelineImage,
                    "Position the camera directly above the crown of the head, ensuring all hair is visible in the circle.",
                    "Next"
                ];
            case 1:
                return [
                    "Right image",
                    RightGuidelineImage,
                    "Position the camera perpendicular to the right side of the face, ensuring all hair is visible in frame.",
                    "Next"
                ];
            case 2:
                return [
                    "Left image",
                    LeftGuidelineImage,
                    "Position the camera perpendicular to the left side of the face, ensuring all hair is visible in frame.",
                    "Got it!"
                ];
            default:
                return [
                    "Crown image",
                    CrownGuidelineImage,
                    "Position the camera directly above the crown of the head, ensuring all hair is visible in the circle.",
                    "Next"
                ];
        }
    }, [activeSlideIndex])

    return (
        <>
            <div className="inset-0 bg-black/50 absolute z-[500]" />
            <div className="z-[501] top-0 left-0 h-screen w-screen absolute flex flex-col items-center justify-center">
                <div className="bg-white rounded-lg p-6 max-w-md mx-4">
                    <h6 className="text-gray-900 text-lg font-bold mb-4 text-center">Image capture guidelines</h6>
                    <p className="text-gray-900 text-base font-medium mb-4 text-center">{imageType}</p>
                    <div className="flex flex-col gap-6 items-center">
                        <img src={imageSrc} className="w-[200px] h-auto rounded-lg" alt="guideline"/>
                        <p className="text-gray-700 text-center">
                            {description}
                        </p>
                        <button onClick={isLastSlide ? onAcceptGuidelines : () => setActiveSlideIndex(activeSlideIndex + 1)} className="px-6 py-2 bg-[#f4831f] text-white font-semibold rounded-md">
                            {buttonText}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default memo(CaptureGuidelines);